import "./Page404.css";
import sentences from './sentences_404.json';

function Page404() {
    function getRandom404Sentance() {
        const randomIndex = Math.floor(Math.random() * sentences.length);
        return sentences[randomIndex];
    }

    return (
        <div className="text-left p-10 md:px-20 container mx-auto">
            <div class="flex flex-col items-center justify-center h-screen" id="page-404">
                <p className="text-[96px]">
                    404
                </p>
                <p className="text-[28px] text-wrap text-center">
                    {getRandom404Sentance()}
                </p>
                <svg width="800" height="400" viewBox="0 0 800 600" xmlns="http://www.w3.org/2000/svg">
                    {/* <!-- Background --> */}
                    <rect width="800" height="400" className="fill-gray-900"/>
                    {/* <!-- Underline accent --> */}
                    <line x1="200" y1="70" x2="600" y2="70" className="stroke-gray-300" stroke-width="4" />
                    {/* <!-- Smiley face --> */}
                    <circle cx="400" cy="180" r="40" fill="none" className="stroke-gray-300" stroke-width="4"/>
                    <circle cx="385" cy="170" r="5" className="fill-gray-300"/>
                    <circle cx="415" cy="170" r="5" className="fill-gray-300"/>
                    <path d="M380,190 Q400,210 420,190" fill="none" className="stroke-gray-300" stroke-width="4"/>
                </svg>
            </div>
        </div>
    );
}

export default Page404;
